'use client';

import { c as _c } from "react/compiler-runtime";
import { Separator, useSiteHeader } from '@repo/ui/components';
import { SidebarTrigger } from '@repo/ui/components';
import { PropsWithChildren } from 'react';
export const SiteHeader = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    component,
    title
  } = useSiteHeader();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SidebarTrigger className="-ml-1" data-sentry-element="SidebarTrigger" data-sentry-source-file="index.tsx" />;
    t2 = <Separator className="mx-2 data-[orientation=vertical]:h-4" orientation="vertical" data-sentry-element="Separator" data-sentry-source-file="index.tsx" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== component || $[3] !== title) {
    t3 = component ? component : <h1 className="text-base font-medium">{title}</h1>;
    $[2] = component;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <header className="flex h-12 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12" data-sentry-component="SiteHeader" data-sentry-source-file="index.tsx"><div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">{t1}{t2}{t3}{children}</div></header>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export * from './context';